// extracted by mini-css-extract-plugin
module.exports = {"mobile":"425px","tablet":"768px","laptop":"1024px","desktop":"1440px","xxl":"2560px"};